export const DRAG_EVENTS = ['mousemove','mouseup','touchmove','touchend'];